import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../app/language/Language';

export default function HeaderLanguageSwitcher({ lang }) {

    const { language } = useSelector(state => state.language);
    const languages = [
        { code: 'eng', label: 'ENG' },
        { code: 'alb', label: 'ALB' },
    ];
    const id = React.useId();
    const buttonId = `${id}-button`;
    const menuId = `${id}-menu`;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => { setAnchorEl(event.currentTarget); };
    const handleClose = () => { setAnchorEl(null); };
    const dispatch = useDispatch();
    const handleLanguageChange = (code) => {
        dispatch(setLanguage(code))
        handleClose();
    };

    return (
        <div>
            <Button id={buttonId} aria-controls={open ? menuId : undefined} aria-haspopup="true" sx={{ color: 'text.secondary', fontSize: 18 }} aria-expanded={open} onClick={handleClick}>
                {languages.find(l => l.code === language)?.label || 'Select Language'}
            </Button>
            <Menu
                id={menuId}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': buttonId,
                    },
                }}
            >
                {languages.map((lang) => (
                    lang.code !== language &&
                    <MenuItem
                        sx={{ color: 'text.secondary' }}
                        key={lang.code}
                        selected={lang.code === language}
                        onClick={() => handleLanguageChange(lang.code)}
                    >
                        {lang.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )
}
